import Linkify from 'linkify-it';
import { isNative } from 'styles';

const linkify = Linkify();

export const linkifyMatch = (text) => linkify.match(text);

export default function linkifyText(text, community, omitUrls) {
  const matches = linkify.match(text);
  if (!matches) return text;
  let offset = 0;
  matches.forEach((match) => {
    const { index, lastIndex, text: txt, url, schema } = match;
    const prependToUrl = schema === '#' && !isNative ? `/${community}` : '';

    // Already a link
    if (
      text[index - 1] === '(' &&
      text[lastIndex] === ')' &&
      !isPreviewUrl(url, omitUrls)
    ) {
      return;
    }

    // Omit link if we have preview
    const link = isPreviewUrl(url, omitUrls) ? '' : `[${txt}](${prependToUrl}${url}) `;

    text = text.slice(0, index + offset) + link + text.slice(lastIndex + offset);
    offset += link.length - (lastIndex - index);
  });
  return text;
}

function isPreviewUrl(url, urlArray = []) {
  if (!url || !urlArray.length) return false;
  for (const u of urlArray)
    if (url.replace(/\/$/, '') === u?.replace(/\/$/, '')) return true;
  return false;
}

linkify.add('@', {
  validate: (text, pos, self) => {
    const tail = text.slice(pos);

    if (!self.re.handle) {
      self.re.handle = new RegExp(
        '^([a-zA-Z0-9_]){1,15}(?!_)(?=$|' + self.re.src_ZPCc + ')'
      );
    }
    if (self.re.handle.test(tail)) {
      // Linkifier allows punctuation chars before prefix,
      // but we additionally disable `@` ("@@mention" is invalid)
      if (pos >= 2 && tail[pos - 2] === '@') {
        return false;
      }
      return tail.match(self.re.handle)[0].length;
    }
    return 0;
  },
  normalize: (match) => {
    isNative
      ? (match.url = '__user_profile__' + match.url.replace(/^@/, ''))
      : (match.url = '/user/profile/' + match.url.replace(/^@/, ''));
  },
});

linkify.add('#', {
  validate: (text, pos, self) => {
    const tail = text.slice(pos);

    if (!self.re.handle) {
      self.re.handle = new RegExp(
        '^([a-zA-Z0-9_]){1,15}(?!_)(?=$|' + self.re.src_ZPCc + ')'
      );
    }
    if (self.re.handle.test(tail)) {
      // Linkifier allows punctuation chars before prefix,
      // but we additionally disable `#` ("##tag" is invalid)
      if (pos >= 2 && tail[pos - 2] === '#') {
        return false;
      }
      return tail.match(self.re.handle)[0].length;
    }
    return 0;
  },
  normalize: (match) => {
    isNative
      ? (match.url = '__tag_link__' + match.url.replace(/^#/, ''))
      : (match.url = `/new/` + match.url.replace(/^#/, ''));
  },
});
